import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import useGetJobsiteByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetJobsiteByID'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import JobsiteCard from 'InstitutionalManagement/components/JobsiteCard'
import SearchJobsiteOnCustomForm from './components/SearchJobsiteOnCustomForm'
import SelectJobsiteOnCustomForm from './components/SelectJobsiteOnCustomForm'
import { useCustomFormJobsiteSelectionDrawerManager } from './contexts/CustomFormJobsiteSelectionDrawerManager/Provider'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormJobsiteSelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getJobsite, loadingJobsite } = useGetJobsiteByID()

  const { selectedJobsite, setSelectedJobsite, view, filter } = useCustomFormJobsiteSelectionDrawerManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_JOBSITE: <SearchJobsiteOnCustomForm onClose={onClose} />,
      SELECT_JOBSITE: <SelectJobsiteOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadjobsite(jobsiteId: string) {
    const jobsiteFromAPI = await getJobsite(jobsiteId)
    setSelectedJobsite(jobsiteFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const jobsiteId = question.default_value[0]
        await loadjobsite(jobsiteId)
      }
      if (question.answer && question.answer.length > 0) {
        const jobsiteId = question.answer[0]
        await loadjobsite(jobsiteId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingJobsite}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedJobsite?.id ? 'Atualizar posto de trabalho' : 'Adicionar posto de trabalho'}
      </Button>

      {selectedJobsite?.id && <JobsiteCard jobsite={selectedJobsite} borderWidth="1px" borderColor="borderColor" />}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormJobsiteSelectionDrawerContent
